import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import { aliases, mdi } from "vuetify/iconsets/mdi";
import "vuetify/styles";
import "@mdi/font/css/materialdesignicons.css";

export default createVuetify({
  theme: {
    // defaultTheme: "light"
  },
  components,
  directives,
  defaults: {
    VSelect: {
      density: "compact",
      variant: "outlined"
    },
    VTextField: {
      density: "compact",
      variant: "outlined"
    },
    VTextarea: {
      density: "compact",
      variant: "outlined"
    }
  },

  icons: {
    defaultSet: "mdi",
    aliases,
    sets: {
      mdi
    }
  }
});
